/** Keep message type in sync with `extension/popup.js` (STYX_EXTENSION_POST_MESSAGE_TYPE). */
export const STYX_EXTENSION_POST_MESSAGE_TYPE = "styx-extension-badge-v1" as const;

export function isStyxExtensionEmbed(): boolean {
  if (typeof window === "undefined") return false;
  const v = new URLSearchParams(window.location.search).get("styx_ext");
  return v === "1" || v === "true";
}

/** Notify Chrome extension popup parent of total unread count (iframe embed only). */
export function postStyxExtensionBadgeTotal(total: number): void {
  if (!isStyxExtensionEmbed()) return;
  if (window.parent === window) return;
  if (!Number.isFinite(total) || total < 0) return;
  try {
    window.parent.postMessage(
      { type: STYX_EXTENSION_POST_MESSAGE_TYPE, total: Math.floor(total) },
      "*",
    );
  } catch {
    /* ignore */
  }
}
